import { CronTasks } from '../../services';
import { createRestSlices, applyReducers } from './rest';

const {
    initialState, resetReducer,
    getReducer, listReducer, updateReducer, duplicateReducer,
    startCreateReducer, createReducer, deleteReducer,
    resetAction, getAction, listAction, updateAction, duplicateAction,
    startCreateAction, createAction, deleteAction
} = createRestSlices(CronTasks);

const RUN_CRON_TASK_START = 'kronos/cron_task/RUN_START';
const RUN_CRON_TASK_SUCCESS = 'kronos/cron_task/RUN_SUCCESS';
const RUN_CRON_TASK_FAILURE = 'kronos/cron_task/RUN_FAILURE';

const runReducer = (state, action) => {
    switch (action.type) {
        case RUN_CRON_TASK_START:
            return {
                ...state,
                isRunning: true,
                runErrorMessage: '',
            };
        case RUN_CRON_TASK_SUCCESS:
            return {
                ...state,
                isRunning: false,
                runErrorMessage: '',
            };
        case RUN_CRON_TASK_FAILURE:
            return {
                ...state,
                isRunning: false,
                runErrorMessage: action.message || '',
            };
        default:
            return state;
    }
};

const extendedInitialState = {
    ...initialState,
    isRunning: false,
    runErrorMessage: '',
};

/* Export reducer */
export default (state = extendedInitialState, action) => {
    return applyReducers(state, action, [
        resetReducer,
        getReducer, listReducer, updateReducer, duplicateReducer,
        startCreateReducer, createReducer, deleteReducer,
        runReducer,
    ]);
}

/* Export CRUD actions */
export const resetCronTasks      = resetAction;
export const startCreateCronTask = startCreateAction;
export const createCronTask      = createAction;
export const loadCronTask        = getAction;
export const loadCronTasks       = listAction;
export const updateCronTask      = updateAction;
export const deleteCronTask      = deleteAction;
export const duplicateCronTask   = duplicateAction;

export const runCronTask = (id, payload) => (dispatch) => {
    dispatch({ type: RUN_CRON_TASK_START });

    return CronTasks.run(id, payload)
        .then(() => {
            dispatch({ type: RUN_CRON_TASK_SUCCESS });
            dispatch(loadCronTask(id));
        })
        .catch((error) => {
            dispatch({
                type: RUN_CRON_TASK_FAILURE,
                message: error?.message || '',
            });
            throw error;
        });
};
